import { forOwn, groupBy, orderBy } from "lodash";
import { Note } from "./Note";
import { NotesListSection } from "./NoteListSection";

export class NoteList {
    private _notes: Note[] = [];

    constructor(notes: Note[]) {
        this._notes = notes;
    }

    get sections() {
        const notesSortedByDate = orderBy(this._notes, (note) => note.contactDate, "desc");
        const notesGroupedByYear = groupBy(notesSortedByDate, (note) => note.contactDate.getFullYear());

        const notesListSections: NotesListSection[] = [];
        forOwn(notesGroupedByYear, (notes, year) => {
            const notesListSection = new NotesListSection(year, notes, true);
            notesListSections.push(notesListSection);
        });

        const notesListSectionsSortedByYear = orderBy(notesListSections, (section) => section.header, "desc");

        return notesListSectionsSortedByYear;
    }
}
